import React from "react";
import { Color } from "../../theme/Color";
import { useSelector } from "react-redux";
import { Font } from "../../theme/Font";
import { Description, Section112, SubTitle, TitleSection } from "../DesignComponent/DesignComponents";

const Digital = () => {
  const data = useSelector(
    (state) =>
      state?.landingPage?.data?.acf
        ?.connect_the_leansuite_to_your_digital_lean_manufacturing
  );
  
  return (
    <>
    <Section112 className="connect-theleansuite" style={{backgroundColor:Color.darkBeige}}>
      <div className="container">
        <div className="row align-items-center justify-content-lg-between justify-content-center">
          <div className="col-lg-5 col-md-7 col-sm-8 text-lg-start text-center">
            <SubTitle
                className="sub-title text-uppercase mb-2"
                style={{ color: Color.darkBlack, fontFamily: Font.medium }}
              >
                {data?.text_before_title}
              </SubTitle>
            <TitleSection className="mb-3">{data?.title}</TitleSection>
            <Description style={{color:Color.lighterGrey}}>{data?.description}</Description>
          </div>
          <div className="col-lg-6 col-md-7 col-sm-8">
            <img src={data?.image} style={{width:"100%"}} alt={data?.title}/>
          </div>
        </div>
      </div>
    </Section112>
    </>
  );
};
export default Digital;
